export default __webpack_public_path__ + "static/saas-bundle-55388e5fe50a3207c8df109ffcaa4d99.jpg";